var _style, _rect, _circle, _g, _text, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiota(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 163 81.8",
    style: {
      enableBackground: "new 0 0 163 81.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#12BFAE;stroke:#252A2E;stroke-width:3;}\n\t.st2{fill:#808080;}\n\t.st3{font-family:'Montserrat-SemiBold';}\n\t.st4{font-size:15.5341px;}\n\t.st5{fill:none;stroke:#404040;stroke-width:3;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.9,
    y: 3.7,
    className: "st0",
    width: 107.1,
    height: 23.9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 29.5,
    cy: 53,
    r: 26.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.158 10.025)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.6,
    cy: 28.5,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.1,
    cy: 33.6,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.4,
    cy: 34.2,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 31.9,
    cy: 38.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35.4,
    cy: 39.9,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27.6,
    cy: 38,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 26.3,
    cy: 41.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30.6,
    cy: 42.1,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 34.1,
    cy: 43.4,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 32.4,
    cy: 46.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.9,
    cy: 44.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 24.6,
    cy: 44.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 27,
    cy: 46.6,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 30.4,
    cy: 48,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.5,
    cy: 49.1,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 26.6,
    cy: 49.7,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 25,
    cy: 47.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.6,
    cy: 46,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 29.7,
    cy: 55.8,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 25,
    cy: 53.8,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.3,
    cy: 57.2,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21.5,
    cy: 51.1,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 18.8,
    cy: 54.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16,
    cy: 56.9,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13.5,
    cy: 54,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16.4,
    cy: 51.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.1,
    cy: 48.3,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15,
    cy: 48.9,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 12.1,
    cy: 51.2,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.5,
    cy: 48.6,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.4,
    cy: 46.3,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.8,
    cy: 44.4,
    r: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14.3,
    cy: 44,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 17,
    cy: 42.8,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 17.7,
    cy: 45.4,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14.3,
    cy: 46.3,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 5,
    cy: 44.1,
    r: 1.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 9.2,
    cy: 41,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 7.5,
    cy: 37,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.5,
    cy: 35.3,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13.2,
    cy: 39.3,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 16.9,
    cy: 38.7,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20,
    cy: 38.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.6,
    cy: 39.6,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23,
    cy: 36.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21,
    cy: 35.5,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 18.4,
    cy: 34.8,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 15.2,
    cy: 34.6,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11,
    cy: 31.6,
    r: 1.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14.6,
    cy: 31,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 17.8,
    cy: 31.1,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 20.4,
    cy: 31.9,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 22.4,
    cy: 33,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.8,
    cy: 34.3,
    r: 0.6
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 59.7812 20.3035)",
    className: "st2 st3 st4"
  }, "Perfection !")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Asset 1"), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M57.7,38.5l-0.2,0.2l-1.1,0.8L57.7,38.5z M58.4,28.5h-2.3c-2.2,0-3.9-1.8-3.9-3.9V6.1c0-2.2,1.8-3.9,3.9-3.9 h101.4c2.2,0,3.9,1.8,3.9,3.9v18.5c0,2.2-1.8,3.9-3.9,3.9H70.9l-13.2,10C61.7,35.3,59.9,30.9,58.4,28.5L58.4,28.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiota);
export default __webpack_public_path__ + "static/media/miota.a54bdc6e4099eab5fd6d141114182753.svg";
export { ForwardRef as ReactComponent };